import { render, staticRenderFns } from "./disclaimerText.vue?vue&type=template&id=5c1cf51d&"
import script from "./disclaimerText.vue?vue&type=script&lang=js&"
export * from "./disclaimerText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports